import { StatusEnum } from '@dermloop/static-values';
import { IsStringDate } from '@dermloop/utils';
import {
  IsBoolean,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
  Validate,
} from 'class-validator';
import { DiagnosisDto } from '../diagnoses';
import { PatientSummaryDto } from './pathological-assessment-request.dtos';

export class TeledermatologicalReferralSearchDto {
  @IsOptional()
  @IsString()
  query?: string;

  @IsOptional()
  @IsEnum(StatusEnum)
  status?: StatusEnum;

  // Search for teledermatological assessment diagnosis
  @IsOptional()
  @IsUUID('all', { each: true })
  accurateDiagnosisIds?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  clinicalDiagnosisIds?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  skinTypes?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  medicalUnitIds?: string[];

  @IsOptional()
  @IsUUID('all', { each: true })
  assessedByIds?: string[];

  @IsOptional()
  @IsUUID()
  conditionTypeId?: string;

  @IsOptional()
  @IsUUID()
  /** @deprecated Use conditionTypeId */
  skinConditionTypeId?: string;

  @IsOptional()
  @IsUUID()
  healthRecordId?: string;

  @IsOptional()
  @IsBoolean()
  isMarkedByUser?: boolean;

  /**
   * Check if date of referral can be parsed as a valid date.
   */
  @IsOptional()
  @Validate(IsStringDate)
  dateOfReferral?: string;

  @IsOptional()
  @IsNumber()
  @Max(30)
  take?: number;

  @IsOptional()
  @IsNumber()
  skip?: number;
}

export interface TeledermatologicalReferralAssignmentSearchResultItemDto {
  id: string;
  createdIso: string;
  userEmail?: string;
}

export class TeledermatologicalReferralSearchResultItemDto {
  referralId: string;
  referralIdNumber: string;
  referralMedicalUnitName: string;
  teledermatologicalAssessmentMedicalUnitName?: string;
  patient: PatientSummaryDto;
  undiagnosable: boolean;
  conditionId?: string;
  /** @deprecated Use conditionId */
  lesionId?: string;
  conditionTypeId: string;
  /** @deprecated Use conditionTypeId */
  skinConditionTypeId?: string;
  conditionIsMarkedByUser?: boolean;
  /** @deprecated Use conditionIsMarkedByUser */
  skinConditionIsMarkedByUser?: boolean;
  clinicalDiagnosis?: DiagnosisDto;
  teledermatologicalDiagnosis?: DiagnosisDto;
  createdDate: Date;
  referrerFirstName?: string;
  referrerLastName?: string;
  teledermatologicalAssessmentUserFirstName?: string;
  teledermatologicalAssessmentUserLastName?: string;
  releasedToAllowedSpecialistGroupMembers: boolean;
  releasedToAllowedSpecialistGroupMembersDateIso?: string;
  // Will be populated only if the user has the permission to view the specialist group members
  referralAssignments?: TeledermatologicalReferralAssignmentSearchResultItemDto[];
}
